import React from "react";
import "./OptionStrikeBars.css";

const OptionStrikeBars = () => {
  const data = [
    { strike: 25400, callOi: 2211, callOiChg: 50000, putOi: 115245, putOiChg: 65695 },
    { strike: 25450, callOi: 776, callOiChg: 599, putOi: 35688, putOiChg: 9985 },
    { strike: 25500, callOi: 12076, callOiChg: 7027, putOi: 183240, putOiChg: 41495 },
    { strike: 25550, callOi: 3143, callOiChg: 2639, putOi: 47456, putOiChg: 13377 },
    { strike: 25600, callOi: 17349, callOiChg: 14802, putOi: 121450, putOiChg: 30183 },
    { strike: 25650, callOi: 27274, callOiChg: 26017, putOi: 85006, putOiChg: 36622 },
    { strike: 25700, callOi: 98475, callOiChg: 89239, putOi: 127979, putOiChg: 1343 },
    { strike: 25750, callOi: 70220, callOiChg: 65489, putOi: 45082, putOiChg: 760 },
    { strike: 25800, callOi: 160406, callOiChg: 137398, putOi: 62836, putOiChg: -44849 },
    { strike: 25850, callOi: 87885, callOiChg: 67720, putOi: 28108, putOiChg: -22661 },
    { strike: 25900, callOi: 206954, callOiChg: 112380, putOi: 65582, putOiChg: -27500 },
    { strike: 25950, callOi: 104855, callOiChg: 43540, putOi: 25572, putOiChg: -17820 }
  ];

  const max = {
    callOi: Math.max(...data.map(d => d.callOi)),
    callOiChg: Math.max(...data.map(d => Math.abs(d.callOiChg))),
    putOi: Math.max(...data.map(d => d.putOi)),
    putOiChg: Math.max(...data.map(d => Math.abs(d.putOiChg)))
  };

  const w = (v, m) => `${(Math.abs(v) / m) * 100}%`;

  return (
    <table className="oi-table">
      <thead>
        <tr>
          <th>CALL OI</th>
          <th className="strike-head">STRIKE</th>
          <th>PUT OI</th>
        </tr>
      </thead>

      <tbody>
        {data.map(row => (
          <tr key={row.strike}>

            {/* CALL OI */}
            <td>
              <div className="bar-cell left">
                <div className="bar green" style={{ width: w(row.callOi, max.callOi) }} />
                <div className="bar orange" style={{ width: w(row.callOiChg, max.callOiChg) }} />
              </div>
            </td>

            {/* STRIKE */}
            <td className="strike">{row.strike}</td>

            {/* PUT OI */}
            <td>
              <div className="bar-cell right">
                <div className="bar green" style={{ width: w(row.putOi, max.putOi) }} />
                <div
                  className={`bar orange ${row.putOiChg < 0 ? "neg" : ""}`}
                  style={{ width: w(row.putOiChg, max.putOiChg) }}
                />
              </div>
            </td>

          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default OptionStrikeBars;
